import styled, { css } from 'styled-components';
import { colorScheme } from '../../theme';

export const Tr = styled.tr<{ clickable?: boolean; sticky?: boolean }>`
  transition: 300ms linear all;

  &:hover {
    background: ${colorScheme.semitransparent};
  }

  ${({ clickable }) =>
    clickable &&
    css`
      cursor: pointer;
    `}

  ${({ sticky }) =>
    sticky &&
    css`
      position: sticky;
      top: 0;
      background: white;
      z-index: 100;

      &:hover {
        background: white;
      }
    `}
`;
